import { render, staticRenderFns } from "./SendStatusPills.vue?vue&type=template&id=86ac5fe4&scoped=true"
import script from "./SendStatusPills.vue?vue&type=script&lang=js"
export * from "./SendStatusPills.vue?vue&type=script&lang=js"
import style0 from "./SendStatusPills.vue?vue&type=style&index=0&id=86ac5fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ac5fe4",
  null
  
)

export default component.exports